import React from 'react';
import { Checkbox, TableHead, TableRow } from '@mui/material';
import { Theme } from '@mui/material/styles';
import DataTableCell from './DataTableCell';

export interface DataTableHeadingsProps {
  dataStructure: Record<string, any>;
  selectable: boolean;
  pagedItems: any[];
  checkedTableItems: Record<string, boolean>;
  handleSelectAll: () => void;
  isAllChecked: (
    pagedItems: any[],
    checked: Record<string, boolean>,
  ) => boolean;
  actions: React.ReactElement[];
}

const DataTableHeadings: React.FC<DataTableHeadingsProps> = ({
  dataStructure,
  selectable,
  pagedItems,
  checkedTableItems,
  handleSelectAll,
  isAllChecked,
  actions,
}) => {
  const headingsArray = [
    ...(selectable
      ? [
          <DataTableCell
            key="cell-heading-select-all-t"
            keyName="cell-heading-select-all"
            size="small"
            isHeader
            sx={{ padding: '10px 12px 10px 1rem' }}
          >
            <Checkbox
              data-testid="select-all-checkbox"
              checked={isAllChecked(pagedItems, checkedTableItems)}
              onClick={handleSelectAll}
            />
          </DataTableCell>,
        ]
      : []),
    ...Object.values(dataStructure).map((heading, index) => (
      <DataTableCell
        key={`cell-heading-${heading}-h`}
        isHeader
        keyName={`cell-heading-${heading}`}
        bold
        sx={(theme: Theme) => ({
          paddingTop: theme.spacing(1),
          paddingBottom: theme.spacing(1),
          paddingLeft:
            !selectable && index > 0 ? theme.spacing(2) : theme.spacing(3),
        })}
      >
        {heading}
      </DataTableCell>
    )),
    ...(actions.length > 0
      ? [
          <DataTableCell
            key="cell-heading-s-t"
            keyName="cell-heading-select-all"
            size="small"
            isHeader
          >
            {' '}
          </DataTableCell>,
        ]
      : []),
  ];
  return (
    <TableHead>
      <TableRow
        sx={(theme: Theme) => ({
          border: `1px solid ${theme.palette.grey[300]}`,
        })}
      >
        {headingsArray}
      </TableRow>
    </TableHead>
  );
};

export default DataTableHeadings;
